import React, { useState, useEffect, useRef } from "react";
import { Modal, ToastContainer } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import {
  UpdatePencil,
  DeleteDustbin,
  ArrowBullet,
  SearchBig,
  CircularGrid,
} from "../AllSvg";
import { BASE_URL } from "../../config/axios";
import { handleErrorToast, DateRangePicker } from "../CustomFunctions";
import "./bid.css";

// ! *************** Add BG Details Component ***************
import * as XLSX from "xlsx";

// ! *************** Update BG Details Component ***************

const UpdateBgDetails = ({ i, getBgDetails, toggleState }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    bg_created: "",
    payer_bank: "",
    bg_creation_date: "",
    bg_expiry_date: "",
    ref_no: "",
    bg_created_on_behalf_of: "",
    bg_created_by: "",
    emd_type: "",
    bg_transcation_date: "",
    account_number: "",
    name_of_account_holder: "",
    transcation_id: "",
    emd_created_proof: "",
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  useEffect(() => {
    if (show) {
      setFormData({
        bg_created: i.bg_created || false,
        payer_bank: i.payer_bank || "",
        bg_creation_date: i.bg_creation_date
          ? i.bg_creation_date.split("T")[0]
          : "",
        bg_expiry_date: i.bg_expiry_date ? i.bg_expiry_date.split("T")[0] : "",
        ref_no: i.ref_no || "",
        bg_created_on_behalf_of: i.bg_created_on_behalf_of || "",
        bg_created_by: i.bg_created_by || "",
        emd_type: i.emd_type || "",
        bg_transcation_date: i.bg_transcation_date || "",
        account_number: i.account_number || "",
        name_of_account_holder: i.name_of_account_holder || "",
        transcation_id: i.transcation_id || "",
      });
    }
  }, [show]);

  const handleClose = () => {
    setShow(false);

    setFormData({
      bg_created: "",
      payer_bank: "",
      bg_creation_date: "",
      bg_expiry_date: "",
      ref_no: "",
      bg_created_on_behalf_of: "",
      bg_created_by: "",
      emd_type: "",
      bg_transcation_date: "",
      account_number: "",
      name_of_account_holder: "",
      transcation_id: "",
      emd_created_proof: "",
    });
  };

  const handleShow = () => {
    setShow(true);
  };

  const validateForm = () => {
    const newErrors = {};
    let requiredFields = [];
    requiredFields = [
      // wishListData.is_jv_allowed === null ? "is_jv_allowed" : null,
      formData.emd_type === "demand_draft" ||
      formData.emd_type === "Bank_Gurantee"
        ? "bg_creation_date"
        : null,
      formData.emd_type === "demand_draft" ||
      formData.emd_type === "Bank_Gurantee"
        ? "bg_expiry_date"
        : null,
      formData.emd_type === "demand_draft" ||
      formData.emd_type === "Bank_Gurantee"
        ? "ref_no"
        : null,
      formData.emd_type === "neft" || formData.emd_type === "card"
        ? "bg_transcation_date"
        : null,
      formData.emd_type === "neft" || formData.emd_type === "card"
        ? "account_number"
        : null,
      formData.emd_type === "neft" || formData.emd_type === "card"
        ? "name_of_account_holder"
        : null,
      "emd_type",
      "bg_created",
      "payer_bank",
      "bg_created_by",
      "emd_created_proof",
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Updating BG details...");

      try {
        const formDataToSend = new FormData();

        // append all fields
        Object.keys(formData).forEach((key) => {
          formDataToSend.append(key, formData[key]);
        });

        // extra condition
        if (toggleState === 1) {
          formDataToSend.append("is_in_created", true);
        }

        let res = await axios.put(
          `${BASE_URL}/siteproject/bgdetailsforbdput/${i.id}/`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200) {
          if (toggleState == 1) {
            try {
              let res = await axios.put(
                `${BASE_URL}/siteproject/tenderforbdupdateemdtype/${i.tender_id}/`,
                {
                  emd_type: formData.emd_type,
                  bgcreatedfor_tender: true,
                },
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                },
              );
            } catch (err) {
              handleErrorToast(err);
            } finally {
              setLoading(false);
              toast.dismiss(loadingToastId);
            }
          }
          await getBgDetails();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Emd details updated successfully!");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;

    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files[0]; // ✅ get file
    } else {
      newValue = value;
    }

    setInputState({
      ...inputState,
      [name]: newValue ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const [showbgdetails, SetshowbgDetails] = useState(false);
  useEffect(() => {
    console.log(formData.bg_created);
    if (show) {
      if (formData.bg_created) {
        SetshowbgDetails(true);
      } else {
        SetshowbgDetails(false);
      }
    }
  }, [show]);

  useEffect(() => {
    // console.log('useffect runijng', formData.bg_created)
    if (formData.bg_created === "true") {
      SetshowbgDetails(true);
    } else {
      SetshowbgDetails(false);
    }
  }, [formData.bg_created]);

  const EmdType = [
    { key: "Bank_Gurantee", value: "Bank Gurantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "suretybond", value: "Surety Bond" },
    { key: "card", value: "Card" },
    { key: "other", value: "Other" },
  ];

  return (
    <>
      <button
        title="Update BG Details"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave large-modal"
        size="lg"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Update Emd Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <div className="form-flex-wrap">
              {/* BG Created */}
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  Emd Created <span className="required">*</span>
                </label>
                <select
                  name="bg_created"
                  value={formData.bg_created}
                  onChange={handleInputChange}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                >
                  <option value=""> Select an option</option>
                  <option value={false}>No</option>
                  <option value={true}>Yes</option>
                </select>
                {errors.bg_created && (
                  <span className="error-message font-size-text ">
                    {errors.bg_created}
                  </span>
                )}
              </div>
              {/* {console.log(showbgdetails, 'bg created')} */}
              {/* Payer Bank */}
              {showbgdetails && (
                <>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Emd Created By <span className="required">*</span>
                    </label>
                    <select
                      name="bg_created_by"
                      value={formData.bg_created_by}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    >
                      <option value=""> Select an option</option>
                      <option value="CIPL">CIPL</option>
                      <option value="SAPL">SAPL</option>
                    </select>
                    {errors.bg_created_by && (
                      <span className="error-message font-size-text ">
                        {errors.bg_created_by}
                      </span>
                    )}
                  </div>
                  <div className="dropdown-wrapper flex justify-center ">
                    <label
                      htmlFor="emd_type"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Emd Type<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      id="emd_type"
                      name="emd_type"
                      value={formData.emd_type}
                      onChange={handleInputChange}
                      className={`form-input font-size-subheading`}
                      // style={{ width: '80% !important' }}
                    >
                      <option value="">EMD Type</option>
                      {EmdType.map((emd) => (
                        <option value={emd.key}>{emd.value}</option>
                      ))}
                    </select>
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Payer Bank <span className="required">*</span>
                    </label>

                    <select
                      name="payer_bank"
                      placeholder="Enter payer bank"
                      value={formData.payer_bank}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    >
                      <option value=""> Select an option</option>
                      <option value="Hdfc Bank">Hdfc Bank</option>
                      <option value="Yes Bank">Yes Bank</option>
                      <option value="Icici Bank">Icici Bank</option>
                    </select>
                    {errors.payer_bank && (
                      <span className="error-message font-size-text ">
                        {errors.payer_bank}
                      </span>
                    )}
                  </div>

                  {/* BG Creation Date */}
                  {formData.emd_type === "demand_draft" ||
                  formData.emd_type === "Bank_Gurantee" ? (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Emd Creation Date <span className="required">*</span>
                      </label>
                      <input
                        type="date"
                        name="bg_creation_date"
                        value={formData.bg_creation_date}
                        onChange={handleInputChange}
                        className="form-input font-weight400 font-size-subheading form-input-background"
                      />
                      {errors.bg_creation_date && (
                        <span className="error-message font-size-text ">
                          {errors.bg_creation_date}
                        </span>
                      )}
                    </div>
                  ) : (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Emd Transcation Date <span className="required">*</span>
                      </label>
                      <input
                        type="date"
                        name="bg_transcation_date"
                        value={formData.bg_transcation_date}
                        onChange={handleInputChange}
                        className="form-input font-weight400 font-size-subheading form-input-background"
                      />{" "}
                      {errors.bg_transcation_date && (
                        <span className="error-message font-size-text ">
                          {errors.bg_transcation_date}
                        </span>
                      )}
                    </div>
                  )}

                  {/* BG Expiry Date */}
                  {(formData.emd_type === "demand_draft" ||
                    formData.emd_type === "Bank_Gurantee") && (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Emd Expiry Date <span className="required">*</span>
                      </label>
                      <input
                        type="date"
                        name="bg_expiry_date"
                        value={formData.bg_expiry_date}
                        onChange={handleInputChange}
                        className="form-input font-weight400 font-size-subheading form-input-background"
                        min={formData.bg_expiry_date}
                      />
                      {errors.bg_expiry_date && (
                        <span className="error-message font-size-text ">
                          {errors.bg_expiry_date}
                        </span>
                      )}
                    </div>
                  )}
                  {(formData.emd_type === "neft" ||
                    formData.emd_type === "card") && (
                    <>
                      <div className="flex-column">
                        <label className="form-labels font-weight500 font-size-subheading">
                          Account Number/Card Number{" "}
                          <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="account_number"
                          placeholder="Enter Account/Card number"
                          value={formData.account_number}
                          onChange={handleInputChange}
                          className="form-input font-weight400 font-size-subheading form-input-background"
                        />
                        {errors.account_number && (
                          <span className="error-message font-size-text ">
                            {errors.account_number}
                          </span>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels font-weight500 font-size-subheading">
                          Name of Account/Card Holder{" "}
                          <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="name_of_account_holder"
                          placeholder="Name of Account/Card Holder"
                          value={formData.name_of_account_holder}
                          onChange={handleInputChange}
                          className="form-input font-weight400 font-size-subheading form-input-background"
                        />
                        {errors.name_of_account_holder && (
                          <span className="error-message font-size-text ">
                            {errors.name_of_account_holder}
                          </span>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels font-weight500 font-size-subheading">
                          Transcation Id
                        </label>
                        <input
                          type="text"
                          name="transcation_id"
                          placeholder="Transcation Id"
                          value={formData.transcation_id}
                          onChange={handleInputChange}
                          className="form-input font-weight400 font-size-subheading form-input-background"
                        />
                        {errors.transcation_id && (
                          <span className="error-message font-size-text ">
                            {errors.transcation_id}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                  {/* Reference No */}
                  {(formData.emd_type === "demand_draft" ||
                    formData.emd_type === "Bank_Gurantee") && (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Reference No <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="ref_no"
                        placeholder="Enter reference number"
                        value={formData.ref_no}
                        onChange={handleInputChange}
                        className="form-input font-weight400 font-size-subheading form-input-background"
                      />
                      {errors.ref_no && (
                        <span className="error-message font-size-text ">
                          {errors.ref_no}
                        </span>
                      )}
                    </div>
                  )}

                  {/* BG Created On Behalf Of */}
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Emd Created On Behalf Of:
                    </label>

                    <select
                      name="bg_created_on_behalf_of"
                      placeholder="Enter on behalf of"
                      value={formData.bg_created_on_behalf_of}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    >
                      <option value=""> Select an option</option>
                      {i.lead_partner && (
                        <option value={i.lead_partner}>{i.lead_partner}</option>
                      )}
                      {i.assosiate_partner && (
                        <option value={i.assosiate_partner}>
                          {i.assosiate_partner}
                        </option>
                      )}
                      {i.jv_partner_name && (
                        <option value={i.jv_partner_name}>
                          {i.jv_partner_name}
                        </option>
                      )}
                    </select>
                  </div>
                  <div style={{ width: "100%" }}>
                    {" "}
                    <div
                      style={{
                        width: "100%",
                        maxWidth: 480,
                        margin: "0",
                        background: "#fff",
                        borderRadius: 8,
                        boxShadow: "0 2px 12px #eee",
                        padding: 32,
                      }}
                    >
                      <label
                        className="form-labels font-weight500 font-size-subheading"
                        style={{
                          marginBottom: 12,
                          display: "block",
                          fontSize: 18,
                          fontWeight: 600,
                        }}
                      >
                        Upload Emd Created Proof{" "}
                        <span className="required">*</span>
                      </label>
                      <input
                        type="file"
                        name="emd_created_proof"
                        onChange={handleInputChange}
                        style={{ marginBottom: 24, width: "100%" }}
                        className="form-control"
                      />

                      {errors.emd_created_proof && (
                        <span className="error-message font-size-text ">
                          {errors.emd_created_proof}
                        </span>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </form>

          <div className="button-models">
            <button
              className="model-button font-weight500 model-button-cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="model-button font-weight500 model-button-leave font-size-heading"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ! *************** Delete BG Details Component ***************

const Addtocart = ({ i, getBgDetails, toggleState }) => {
  const [show, setShow] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [toggleEmployeeCode, settoggleEmployeeCode] = useState([]);

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Processing...");

    const { emd_created_proof, ...updatedData } = { ...i };

    if (toggleState === 1) {
      updatedData.is_in_created = true;
    }

    if (toggleState === 2) {
      updatedData.is_submitted = true;
    }

    if (toggleState === 3) {
      updatedData.is_matured = true;
    }

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/bgdetailsforbdput/${i.id}/`,
        updatedData,
        { headers: { "Content-Type": "application/json" } },
      );

      if (res.status === 200) {
        await getBgDetails();
        setShow(false);
        toast.success(
          toggleState === 1
            ? "Created Bg"
            : toggleState === 2
              ? "Submitted Bg"
              : "Rejected",
        );
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Move To Next"
        onClick={handleShow}
        style={{
          cursor: "pointer",
          width: "2.7rem",
          height: "2.7rem",
          backgroundColor: "#2576bc",
          color: "white",
          borderRadius: "50%",
          fontSize: "1.5rem",
        }}
      >
        <ArrowBullet color={"white"} />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Move Tender To{" "}
            {toggleState === 1
              ? "Created Bg"
              : toggleState === 2
                ? "Submitted Bg"
                : "Rejected"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            Are you sure you want to move this tender ({i.tender_name} Bg )?
            <div className="button-models">
              <button
                className="model-button model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmit}
                className="model-button model-button-delete"
              >
                Confirm
              </button>
            </div>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ! *************** Main BG Details Component ***************
const UploadBgOld = ({ getBgOldData }) => {
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const bulktableRef = useRef(null);
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/bg_format.xlsx"; // directly from public
    link.setAttribute("download", "Bg_Details.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleClose = () => {
    setFileName("");
    setExcelJson(null);
    setDocErrors({});
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // Function to handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    setDocErrors({});
    if (file) {
      // Check for valid file type
      const validFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (!validFileTypes.includes(file.type)) {
        setDocErrors({
          document_file: "Please upload a valid Excel file (.xlsx or .xls).",
        });
        setFileName("");
        return;
      }

      setFileName(file.name);
      readExcel(file); // Convert the file to JSON
    } else {
      setFileName("");
    }
  };
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // dd-mm-yyyy
    }
    return dateStr; // if already formatted differently
  };

  const checkForDuplicates = (data) => {
    const sitecodes = new Map();
    const duplicates = [];

    // Track positions of each insurance number
    data.forEach((i, index) => {
      const projectcode = i.tender_id;
      if (sitecodes.has(projectcode)) {
        // If the insurance number already exists, add the current position to its list
        sitecodes.get(projectcode).push(index + 1); // index + 1 for 1-based position
      } else {
        // If it's the first time seeing this insurance number, initialize its position list
        sitecodes.set(projectcode, [index + 1]);
      }
    });

    // Now, filter out only the numbers that appear more than once
    sitecodes.forEach((positions, projectcode) => {
      if (positions.length > 1) {
        duplicates.push(
          `\Tender Id :${projectcode} is found in position(s) ${positions.join(", ")}`,
        );
      }
    });

    return duplicates;
  };

  const readExcel = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert entire sheet into 2D array
      const sheetData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: null,
      });

      // 🔹 Define the allowed fields (your schema)
      const fields = [
        "project_name",
        "project_name_in_detail",
        "bg",
        "work_type",
        "lead_firm",
        "jv",
        "association_firm",
        "on_behalf_of",
        "type",
        "type_of_security",
        "bank_gurentee_no",
        "bank_gurentee_issue_date",
        "bg_expiry_date",
        "claim_period",
        "benificiary_name",
        "bg_amount",
        "fd_number",
        "margin",
        "submitted_to_bd_dept",
        "submitted_date",
        "person_name",
        "bank_name",
        "company_name",
        "limit",
        "sfms",
        "responsibility",
      ];

      // 🔹 Helper: Convert to yyyy-mm-dd regardless of Excel format
      const convertToYYYYMMDD = (input) => {
        try {
          if (!input) return null;
          let date;

          // Excel serial numbers
          if (typeof input === "number") {
            const excelEpoch = new Date(1899, 11, 30);
            date = new Date(excelEpoch.getTime() + input * 86400000);
          }
          // Text formats
          else if (typeof input === "string") {
            let normalized = input.trim().replace(/[\.\s/]+/g, "-");

            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(normalized)) {
              const [d, m, y] = normalized.split("-");
              date = new Date(
                `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`,
              );
            } else if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(normalized)) {
              const [y, m, d] = normalized.split("-");
              date = new Date(
                `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`,
              );
            } else {
              date = new Date(normalized);
            }
          } else {
            date = new Date(input);
          }

          if (isNaN(date.getTime())) return null;
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        } catch {
          return null;
        }
      };

      const normalize = (str) =>
        str
          ?.toString()
          .replace(/[\n\r\t]/g, "") // ❗ REMOVE hidden chars
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase();

      // 🔹 Identify header row (match by fields array)
      // console.log(sheetData)
      const headerRowIndex = sheetData.findIndex((row) => {
        if (!Array.isArray(row)) return false;

        const normalizedRow = row.map(normalize);

        return fields.every((field) =>
          normalizedRow.includes(normalize(field)),
        );
      });
      console.log(headerRowIndex);

      if (headerRowIndex === -1) {
        toast.error("❌ Correct header row not found in Excel sheet.");
        return;
      }

      const headers = sheetData[headerRowIndex];
      const dataRows = sheetData.slice(headerRowIndex + 1);

      // 🔹 Map rows → objects filtered by fields
      const formattedJson = dataRows.map((row) => {
        const obj = {};
        headers.forEach((header, idx) => {
          if (fields.includes(header)) {
            const val = row[idx];
            if (
              [
                "bank_gurentee_issue_date",
                "bg_expiry_date",
                "claim_period",
                "submitted_date",
              ].includes(header)
            ) {
              obj[header] = convertToYYYYMMDD(val);
            } else if (typeof val === "string") {
              obj[header] = val.trim();
            } else {
              obj[header] = val ?? null;
            }
          }
        });
        return obj;
      });

      // 🔹 Remove empty rows
      const nonEmptyRows = formattedJson.filter((row) =>
        Object.values(row).some((val) => val !== null && val !== ""),
      );

      // 🔹 Validate publish_date ≤ submission_date

      // ✅ Set parsed Excel JSON
      setExcelJson(nonEmptyRows);
    };

    reader.readAsArrayBuffer(file);
  };

  const [validationErrors, setValidationErrors] = useState([]);

  // Function to handle the upload button click
  const handleUpload = async () => {
    if (!excelJson) {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
      return;
    }

    const errors = [];
    const seenTenderIds = new Map();

    excelJson?.forEach((row, i) => {
      if (!row.project_name) errors.push(`Row ${i + 2}: Project Name required`);
      if (!row.bank_gurentee_no)
        errors.push(`Row ${i + 2}: BG Number required`);
      if (!row.bg_amount) errors.push(`Row ${i + 2}: Amount required`);
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      return;
    }

    // ✅ No validation errors → clear UI & continue upload
    setValidationErrors([]);

    const loadingToastId = toast.loading("Uploading: Please wait...");

    try {
      const res = await axios.post(
        `${BASE_URL}/siteproject/bgdetailsforbdold/`,
        excelJson,
      );
      if (res.status === 200 || res.status === 201) {
        await getBgOldData();
        handleClose();
        toast.dismiss(loadingToastId);
        toast.success("Bg uploaded successfully.");
      } else {
        toast.dismiss(loadingToastId);
        toast.error("Failed to add data!");
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const fields = [
    "project_name",
    "project_name_in_detail",
    "bg",
    "work_type",
    "lead_firm",
    "jv",
    "association_firm",
    "on_behalf_of",
    "type",
    "type_of_security",
    "bank_gurentee_no",
    "bank_gurentee_issue_date",
    "bg_expiry_date",
    "claim_period",
    "benificiary_name",
    "bg_amount",
    "fd_number",
    "margin",
    "submitted_to_bd_dept",
    "submitted_date",
    "person_name",
    "bank_name",
    "company_name",
    "limit",
    "sfms",
    "responsibility",
  ];
  const dateFields = [
    "bank_gurentee_issue_date",
    "bg_expiry_date",
    "claim_period",
    "submitted_date",
  ];

  const toTitleCase = (str) =>
    str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <>
      <button
        title="Upload"
        className="model-button   font-weight500   model-button-print"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="22"
          id="upload"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
          </g>
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Upload Bulk Bg Data in format :</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-row align-center">
            <button
              onClick={handleDownload}
              className="model-button-download model-button font-weight500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="download"
                fill="#fff"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Format
            </button>
          </div>

          <div
            className="table-css-white-background"
            style={{ display: "none" }}
          >
            <table ref={bulktableRef} className="nested-table-lightblue">
              <thead>
                <tr className="custom-table-head-tr">
                  {fields.map((field, index) => (
                    <th key={index}>{field}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {excelJson?.map((project, rowIndex) => (
                  <tr key={rowIndex}>
                    {fields.map((field, colIndex) => (
                      <td key={colIndex}>
                        {typeof project[field] === "boolean"
                          ? project[field]
                            ? "Yes"
                            : "No"
                          : dateFields.includes(field) && project[field]
                            ? project[field]
                            : project[field]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table-css-white-background scroll-container">
            <div
              className="table-container scrollbar"
              style={{ width: "100%" }}
            >
              <table
                className="nested-table-lightblue"
                style={{ margin: "0px" }}
              >
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    {fields.map((field, index) => (
                      <th key={index} className="table-heading-text">
                        {toTitleCase(field)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelJson?.map((project, rowIndex) => (
                    <tr key={rowIndex} className="modal-padding-heading">
                      {fields.map((field, colIndex) => (
                        <td key={colIndex} className="table-heading-text">
                          {typeof project[field] === "boolean"
                            ? project[field]
                              ? "Yes"
                              : "No"
                            : dateFields.includes(field) && project[field]
                              ? formatDisplayDate(project[field])
                              : project[field]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex-column field-cont-div">
            <label
              htmlFor="document_file"
              className="form-labels announce-date font-weight500 font-size-heading"
            >
              Upload File
            </label>
            <label
              htmlFor="document_file"
              className={`align-center form-inputss custom-file-upload ${
                docErrors.document_file
                  ? "error"
                  : docInputState.document_file
                    ? "success"
                    : ""
              }`}
            >
              <svg
                className="pdf-input"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                  stroke="#707070"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-inputs align-center"
              style={{ display: "none", position: "relative" }}
            />
            {fileName && <p className="file-name align-center">{fileName}</p>}
            <br />
            {docErrors.document_file && (
              <span className="file-name error-message font-size-text ">
                {docErrors.document_file}
              </span>
            )}
          </div>

          <div className="button-models">
            <button
              className="model-button-cancel model-button font-weight500"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="model-button-download model-button font-weight500"
              onClick={handleUpload}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="upload"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Upload
            </button>
          </div>
          {validationErrors.length > 0 && (
            <div
              style={{
                background: "#ffecec",
                border: "1px solid #f5c2c7",
                color: "#842029",
                borderRadius: "6px",
                padding: "10px",
                marginTop: "15px",
                fontSize: "14px",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              <strong>Validation Errors:</strong>
              <ul style={{ marginTop: "5px", paddingLeft: "20px" }}>
                {validationErrors.map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
              </ul>
            </div>
          )}

          <h4 style={{ marginBottom: "1rem" }}>References:</h4>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};
const SubmittedTender = () => {
  const [buffer, setBuffering] = useState(true);
  const [bgData, setBgData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const location = useLocation();
  const [tenderId, setTenderId] = useState("");
  const [summaryData, setSummaryData] = useState({});
  const [dueDateSort, setDueDateSort] = useState("asc");
  console.log(location.state, "location");

  const getBgDetails = async () => {
    setBuffering(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/bgdetailsforbdpost/`,
      );
      setBgData(response.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getBgDetails();
    if (location.state?.project) {
      setTenderId(location.state.project);
    }
  }, [location]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-GB");
  };

  const formatBoolean = (value) => {
    if (value === true || value === "true") return "Yes";
    if (value === false || value === "false") return "No";
    return value || "-";
  };
  const [toggleState, setToggleState] = useState(1);
  const [activeCard, setActiveCard] = useState(null);
  const [bgSubTab, setBgSubTab] = useState("new");
  const [bgOldData, setBgOldData] = useState([]);
  const getBgDetailsold = async () => {
    // setBuffering(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/bgdetailsforbdold/`,
      );
      setBgOldData(response.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // setBuffering(false);
    }
  };

  const calculateSummaryData = (data) => {
    const result = {};

    data.forEach((item) => {
      let key;
      let shouldInclude = false;

      if (toggleState === 1) {
        // Upcoming EMD - Group by EMD Type
        shouldInclude =
          item?.is_in_upcoming &&
          !item?.is_in_created &&
          !item?.is_submitted &&
          !item?.is_matured;
        if (shouldInclude) {
          key = item.emd_type || "Unknown";
        }
      } else if (toggleState === 2) {
        // Created EMD - Group by Sector
        shouldInclude =
          item?.is_in_upcoming &&
          item?.is_in_created &&
          !item?.is_submitted &&
          !item?.is_matured;
        if (shouldInclude) {
          key = item.sector || "Unknown";
        }
      } else if (toggleState === 3) {
        // Submitted EMD - Group by Client
        shouldInclude =
          item?.is_in_upcoming &&
          item?.is_in_created &&
          item?.is_submitted &&
          !item?.is_matured;
        if (shouldInclude) {
          key = item.client || "Unknown";
        }
      } else if (toggleState === 4) {
        // Matured EMD - Group by Client
        shouldInclude =
          item?.is_in_upcoming &&
          item?.is_in_created &&
          item?.is_submitted &&
          item?.is_matured;
        if (shouldInclude) {
          key = item.client || "Unknown";
        }
      } else if (toggleState === 5) {
        // Old BG Records - Group by Type
        shouldInclude = true;
        key = item.type || "Unknown";
      }

      if (shouldInclude && key) {
        let rawAmount = toggleState === 5 ? item.bg_amount : item.emd_amount;
        let amount = Number(String(rawAmount).replace(/,/g, "")) || 0;

        if (!result[key]) {
          result[key] = {
            total: 0,
            count: 0,
          };
        }

        result[key].total += amount;
        result[key].count += 1;
      }
    });

    console.log(
      toggleState,
      bgSubTab,
      result,
      "console in summary based on filtered data",
    );
    return result;
  };

  // Update summary data whenever filteredData or toggleState changes
  useEffect(() => {
    const newSummaryData = calculateSummaryData(filteredData);
    setSummaryData(newSummaryData);
  }, [filteredData, toggleState]);
  const [expandedState, setExpandedState] = useState("closed"); // 'closed', 'sectors', 'clients', 'cards', 'details'
  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedEmdType, setSelectedEmdType] = useState(null);
  const [activeCardKey, setActiveCardKey] = useState(null);

  // Get unique sectors with counts from filtered data
  const getSectorsWithCounts = () => {
    const sectors = {};
    filteredData
      .filter((item) => {
        // Filter by current toggleState to ensure we only show sectors from the active tab
        if (toggleState === 1) {
          return (
            item?.is_in_upcoming &&
            !item?.is_in_created &&
            !item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 2) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            !item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 3) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 4) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            item?.is_submitted &&
            item?.is_matured
          );
        }
        return false;
      })
      .forEach((item) => {
        const sector = item.sector || "Unknown";
        if (!sectors[sector]) {
          sectors[sector] = 0;
        }
        sectors[sector]++;
      });
    return Object.entries(sectors)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  };

  // Get EMD details for a specific type, sector, and client
  const getEmdDetails = (sector, client, emdType) => {
    return filteredData.filter(
      (item) =>
        item.sector === sector &&
        item.client === client &&
        item.emd_type === emdType,
    );
  };

  // Reset handler
  const handleReset = () => {
    setExpandedState("closed");
    setSelectedSector(null);
    setSelectedClient(null);
    setSelectedEmdType(null);
    setActiveCardKey(null);
  };

  // Get unique clients for selected sector with counts
  const getClientsWithCounts = (sector) => {
    const clients = {};
    filteredData
      .filter((item) => {
        // Filter by sector
        if (item.sector !== sector) return false;

        // Also filter by current toggleState to ensure we only show clients from the active tab
        if (toggleState === 1) {
          return (
            item?.is_in_upcoming &&
            !item?.is_in_created &&
            !item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 2) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            !item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 3) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 4) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            item?.is_submitted &&
            item?.is_matured
          );
        }
        return false;
      })
      .forEach((item) => {
        const client = item.client || "Unknown";
        if (!clients[client]) {
          clients[client] = 0;
        }
        clients[client]++;
      });
    return Object.entries(clients).map(([name, count]) => ({ name, count }));
  };

  // Get EMD types for selected sector and client with counts
  const getEmdTypesWithCounts = (sector, client) => {
    const emdTypes = {};
    filteredData
      .filter((item) => {
        // Filter by sector and client
        const sectorClientMatch =
          item.sector === sector && item.client === client;
        if (!sectorClientMatch) return false;

        // Also filter by current toggleState to ensure we only show EMDs from the active tab
        if (toggleState === 1) {
          return (
            item?.is_in_upcoming &&
            !item?.is_in_created &&
            !item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 2) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            !item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 3) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            item?.is_submitted &&
            !item?.is_matured
          );
        } else if (toggleState === 4) {
          return (
            item?.is_in_upcoming &&
            item?.is_in_created &&
            item?.is_submitted &&
            item?.is_matured
          );
        }
        return false;
      })
      .forEach((item) => {
        const type = item.emd_type || "Unknown";
        if (!emdTypes[type]) {
          emdTypes[type] = { count: 0, amount: 0 };
        }
        emdTypes[type].count++;
        emdTypes[type].amount +=
          Number(String(item.emd_amount).replace(/,/g, "")) || 0;
      });
    return Object.entries(emdTypes).map(([name, data]) => ({ name, ...data }));
  };

  const getDueDays = (expiryDate, transactionDate) => {
    const targetDate = expiryDate || transactionDate;

    if (!targetDate) return "-";

    const today = new Date();
    const target = new Date(targetDate);

    // remove time part for accurate day diff
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    const diffTime = target - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  useEffect(() => {
    getBgDetailsold();
  }, []);

  // useEffect(() => {

  //     if (bgSubTab === "old") {

  //         getSummaryData()
  //     }
  // }, [bgSubTab]);
  const [search, setSearch] = useState("");
  const [tendername, setTendername] = useState("");
  const [clientname, setClientname] = useState("");
  const [emdType, setEmdType] = useState("");
  const [projectname, setProjectname] = useState("");
  const [emdtypeold, setEmdTypeold] = useState("");
  const [selectedFromDate, setFromDate] = useState(null);
  const [selectedToDate, setToDate] = useState(null);
  const applyFilters = () => {
    let filteredData = toggleState === 5 ? bgOldData : bgData;
    if (search !== "") {
      const lowercaseSelectedName = search.toLowerCase();
      filteredData = filteredData.filter((project) => {
        const tenderId = project.tender_id
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return tenderId;
      });
    }

    if (clientname !== "") {
      const lowercaseSelectedName = clientname.toLowerCase();
      filteredData = filteredData.filter((project) => {
        const tenderId = project.client
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return tenderId;
      });
    }

    if (tendername !== "") {
      const lowercaseSelectedName = tendername.toLowerCase();
      filteredData = filteredData.filter((project) => {
        const tenderId = project.tender_name
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return tenderId;
      });
    }

    if (emdType !== "") {
      const lowercaseSelectedName = emdType.toLowerCase();
      filteredData = filteredData.filter((project) => {
        const emdType = project.emd_type
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return emdType;
      });
    }

    if (projectname !== "") {
      const lowercaseSelectedName = projectname.toLowerCase();
      filteredData = filteredData.filter((project) => {
        const projectname = project.project_name
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return projectname;
      });
    }

    if (emdtypeold !== "") {
      const lowercaseSelectedName = emdtypeold.toLowerCase();
      filteredData = filteredData.filter((project) => {
        const emdTypeold = project.type
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return emdTypeold;
      });
    }

    if (selectedFromDate != null && selectedFromDate != null) {
      const fromDate = new Date(selectedFromDate);
      const toDate = new Date(selectedToDate);

      filteredData = filteredData.filter((project) => {
        if (!project.bg_expiry_date) return false;

        const expiryDate = new Date(project.bg_expiry_date);

        return expiryDate >= fromDate && expiryDate <= toDate;
      });
    }

    console.log(
      filteredData,
      bgData,
      selectedFromDate,
      selectedToDate,
      "filteredData",
    );

    setFilteredData(filteredData);
  };

  useEffect(() => {
    console.log(emdType, "emdtype");
    applyFilters();
  }, [
    search,
    clientname,
    tendername,
    emdType,
    projectname,
    emdtypeold,
    selectedFromDate,
    selectedToDate,
    toggleState,
    bgSubTab,
    bgData,
    bgOldData,
  ]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    setIsCollapsed(!isCollapsed);
  };

  const [isCollapsed, setIsCollapsed] = useState(true);
  const EmdType = [
    { key: "Bank_Gurantee", value: "Bank Gurantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "suretybond", value: "Surety Bond" },
    { key: "card", value: "Card" },
    { key: "other", value: "Other" },
  ];
  const [dueAlerts, setDueAlerts] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    if (toggleState === 2) {
      const filtered = bgData
        .filter((item) => {
          return (
            item?.is_in_created &&
            item?.is_in_upcoming &&
            !item?.is_submitted &&
            !item?.is_matured
          );
        })
        .filter((item) => {
          const days = getDueDays(
            item.bg_expiry_date,
            item.bg_transcation_date,
          );
          return days !== "-" && days <= 3;
        });

      setDueAlerts(filtered);
      setShowPopup(filtered.length > 0);
    } else {
      setShowPopup(false);
    }
  }, [toggleState, bgData]);
  return (
    <>
      <Dashboardnavbar name="EMD Details" url="BgDetails" />

      <div className="content-tabs">
        {showPopup && (
          <div className="due-popup-right">
            <div className="due-popup-header">
              <h4>⚠️ Due Alerts</h4>
              <button onClick={() => setShowPopup(false)}>✕</button>
            </div>

            <div className="due-popup-body">
              {dueAlerts.map((item, index) => {
                const days = getDueDays(
                  item.bg_expiry_date,
                  item.bg_transcation_date,
                );

                return (
                  <div key={index} className="due-card">
                    <p className="item-title">{item.tender_id || "Item"}</p>
                    <p>
                      Due in: <span className="alert-text">{days} days</span>
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className="header">
          <div className="tab-container">
            {/* Upcoming Tenders Tab */}

            <button
              className={toggleState === 1 ? "tab-btn active" : "tab-btn"}
              onClick={() => {
                setToggleState(1);
                handleReset();
              }}
            >
              <i className="fas fa-bolt"></i> Upcoming Emd (
              {bgData
                ? bgData.filter((tender) => {
                    return (
                      tender?.is_in_upcoming &&
                      !tender?.is_in_created &&
                      !tender?.is_submitted
                    );
                  }).length
                : ""}
              )
            </button>

            <button
              className={toggleState === 2 ? "tab-btn active" : "tab-btn"}
              onClick={() => {
                setToggleState(2);
                handleReset();
              }}
            >
              <i className="fas fa-clipboard-list"></i> Created Emd (
              {bgData
                ? bgData.filter((tender) => {
                    return (
                      tender?.is_in_upcoming &&
                      tender?.is_in_created &&
                      !tender?.is_submitted
                    );
                  }).length
                : ""}
              )
            </button>

            <button
              className={toggleState === 3 ? "tab-btn active" : "tab-btn"}
              onClick={() => {
                setToggleState(3);
                handleReset();
              }}
            >
              <i className="fas fa-check-circle"></i> Submitted Emd (
              {bgData
                ? bgData.filter((tender) => {
                    return (
                      tender?.is_in_upcoming &&
                      tender?.is_in_created &&
                      tender?.is_submitted &&
                      !tender?.is_matured
                    );
                  }).length
                : ""}
              )
            </button>
            <button
              className={toggleState === 4 ? "tab-btn active" : "tab-btn"}
              onClick={() => {
                setToggleState(4);
                handleReset();
              }}
            >
              <i className="fas fa-check-circle"></i> Matured Emd (
              {bgData
                ? bgData.filter((tender) => {
                    return (
                      tender?.is_in_upcoming &&
                      tender?.is_in_created &&
                      tender?.is_submitted &&
                      tender?.is_matured
                    );
                  }).length
                : 0}
              )
            </button>
            {/* <button
                            className={toggleState === 5 ? "tab-btn active" : "tab-btn"}
                            onClick={() => {
                                setToggleState(5);

                                setActiveKey(null);

                            }}
                        >
                            <i className="fas fa-check-circle"></i> Emd before 31st March
                            (
                            {

                                (bgOldData
                                    ? bgOldData
                                    : 0
                                ).length


                            }
                            )
                        </button> */}
          </div>

          <div className="filter-section">
            <button className="print-btn">
              <i className="fas fa-print"></i>
            </button>
          </div>
        </div>
        {/* PROGRESSIVE ACCORDION SYSTEM - Click to Expand */}
        <div className="accordion-main-container">
          {/* STEP 1: Total EMD Value Button - Expand to show sectors */}
          <div
            className={`accordion-trigger-button ${expandedState !== "closed" ? "active" : ""}`}
            onClick={() => {
              if (expandedState === "closed") {
                setExpandedState("sectors");
                setSelectedSector(null);
                setSelectedClient(null);
              } else {
                handleReset();
              }
            }}
          >
            <div className="button-content">
              <div className="button-label">Total EMD Value</div>
              <div className="button-value">
                ₹{" "}
                {Object.values(summaryData)
                  .reduce((a, b) => a + b.total, 0)
                  .toLocaleString("en-IN")}
              </div>
              <div className="button-meta">
                {Object.values(summaryData).reduce((a, b) => a + b.count, 0)}{" "}
                EMDs
              </div>
            </div>
            <div className="button-icon">
              <span>{expandedState !== "closed" ? "−" : "+"}</span>
            </div>
          </div>

          {/* LEVEL 1: Sectors List - Full Width Expansion */}
          {expandedState !== "closed" && filteredData.length > 0 && (
            <div
              className={`accordion-expansion sectors-panel ${expandedState === "sectors" ? "expanded" : "hidden"}`}
            >
              <div className="expansion-header">
                <h3>Select Sector</h3>
                <span className="count-badge">
                  {getSectorsWithCounts().length} Sectors
                </span>
              </div>
              <div className="sectors-grid">
                {getSectorsWithCounts().map((sector) => (
                  <div
                    key={sector.name}
                    className={`sector-card ${selectedSector === sector.name ? "selected" : ""}`}
                    onClick={() => {
                      setSelectedSector(sector.name);
                      setSelectedClient(null);
                      setExpandedState("clients");
                      setActiveCardKey(null);
                    }}
                  >
                    <div className="card-header-text">
                      <div className="sector-name">{sector.name}</div>
                      <div className="sector-count">{sector.count}</div>
                    </div>
                    <div className="card-footer">
                      <span className="sector-items">{sector.count} Items</span>
                      <span className="expand-arrow">→</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* LEVEL 2: Clients List - Expanded Below Sectors */}
          {expandedState === "clients" && selectedSector && (
            <div className="accordion-expansion clients-panel">
              <div className="expansion-header">
                <button
                  className="back-button"
                  onClick={() => setExpandedState("sectors")}
                >
                  <span>←</span> Back to Sectors
                </button>
                <h3>{selectedSector}</h3>
                <span className="count-badge">
                  {getClientsWithCounts(selectedSector).length} Clients
                </span>
              </div>
              <div className="clients-list">
                {getClientsWithCounts(selectedSector).length > 0 ? (
                  getClientsWithCounts(selectedSector).map((client) => (
                    <div
                      key={client.name}
                      className={`client-row ${selectedClient === client.name ? "selected" : ""}`}
                      onClick={() => {
                        setSelectedClient(client.name);
                        setExpandedState("cards");
                      }}
                    >
                      <div className="row-content">
                        <div className="client-name">{client.name}</div>
                        <div className="client-meta">
                          {client.count} EMD Types
                        </div>
                      </div>
                      <div className="row-action">
                        <span className="expand-arrow">→</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="empty-state">No clients found</div>
                )}
              </div>
            </div>
          )}

          {/* LEVEL 3: EMD Type Cards - Full Expansion */}
          {toggleState !== 1 &&
            expandedState === "cards" &&
            selectedSector &&
            selectedClient && (
              <div className="accordion-expansion cards-panel">
                <div className="expansion-header">
                  <button
                    className="back-button"
                    onClick={() => setExpandedState("clients")}
                  >
                    <span>←</span> Back to Clients
                  </button>
                  <h3>{selectedClient}</h3>
                  <span className="count-badge">
                    {
                      getEmdTypesWithCounts(selectedSector, selectedClient)
                        .length
                    }{" "}
                    EMD
                  </span>
                </div>
                <div className="emd-cards-grid">
                  {getEmdTypesWithCounts(selectedSector, selectedClient)
                    .length > 0 ? (
                    getEmdTypesWithCounts(selectedSector, selectedClient).map(
                      (emdType) => (
                        <div
                          key={emdType.name}
                          className={`emd-card ${activeCardKey === emdType.name ? "expanded" : ""}`}
                          onClick={() => {
                            setSelectedEmdType(emdType.name);
                            setExpandedState("details");
                          }}
                        >
                          <div className="emd-card-header">
                            <h4>
                              {emdType.name
                                ?.replace(/_/g, " ")
                                ?.replace(/\b\w/g, (c) => c.toUpperCase())}
                            </h4>
                            <div className="emd-badge">{emdType.count}</div>
                          </div>
                          <div className="emd-card-body">
                            <div className="emd-value">
                              <span className="label">Total Amount</span>
                              <span className="amount">
                                ₹ {emdType.amount.toLocaleString("en-IN")}
                              </span>
                            </div>
                            <div className="emd-stats">
                              <div className="stat">
                                <span className="stat-label">Items</span>
                                <span className="stat-value">
                                  {emdType.count}
                                </span>
                              </div>
                              {/* <div className="stat">
                                                        <span className="stat-label">Per Item</span>
                                                        <span className="stat-value">₹{(emdType.amount / emdType.count).toLocaleString("en-IN", { maximumFractionDigits: 0 })}</span>
                                                    </div> */}
                            </div>
                          </div>
                        </div>
                      ),
                    )
                  ) : (
                    <div className="empty-state">No EMD types found</div>
                  )}
                </div>
              </div>
            )}

          {/* LEVEL 4: EMD Details - Detailed List View */}
          {expandedState === "details" &&
            selectedSector &&
            selectedClient &&
            selectedEmdType && (
              <div className="accordion-expansion details-panel">
                <div className="expansion-header">
                  <button
                    className="back-button"
                    onClick={() => setExpandedState("cards")}
                  >
                    <span>←</span> Back to EMD Types
                  </button>
                  <h3>{selectedEmdType}</h3>
                  <span className="count-badge">
                    {
                      getEmdDetails(
                        selectedSector,
                        selectedClient,
                        selectedEmdType,
                      ).length
                    }{" "}
                    Items
                  </span>
                </div>
                <div className="details-container">
                  <div className="details-grid">
                    {getEmdDetails(
                      selectedSector,
                      selectedClient,
                      selectedEmdType,
                    ).length > 0 ? (
                      getEmdDetails(
                        selectedSector,
                        selectedClient,
                        selectedEmdType,
                      ).map((item, index) => (
                        <div key={index} className="detail-card">
                          <div className="detail-card-header">
                            <span className="detail-id">
                              {item.tender_id || item.id || "N/A"}
                            </span>
                            <span className="detail-sr">#{index + 1}</span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">NAME</span>
                            <span className="detail-value">
                              {item.tender_name || "N/A"}
                            </span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">CLIENT</span>
                            <span className="detail-badge">
                              {item.client || "N/A"}
                            </span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">SECTOR</span>
                            <span className="detail-badge sector">
                              {item.sector || "N/A"}
                            </span>
                          </div>
                          <div className="detail-row highlight">
                            <span className="detail-label">EMD</span>
                            <span className="detail-amount">
                              ₹{(item.emd_amount || 0).toLocaleString("en-IN")}
                            </span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="empty-state">No EMD details found</div>
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>

        <div className="filters-card" style={{ marginBottom: "20px" }}>
          <div
            className="filters-header"
            onClick={toggleCollapse}
            role="button"
          >
            <h3 className="filters-title">Filters</h3>
            <button className="collapse-btn" aria-label="toggle filters">
              {isCollapsed ? (
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="#0b85d8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path
                    d="M18 15L12 9L6 15"
                    stroke="#0b85d8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          </div>

          {!isCollapsed && (
            <div className="filters-form">
              <div className="filter-row full-width">
                {(toggleState === 1 ||
                  toggleState === 2 ||
                  toggleState === 3 ||
                  toggleState === 4) && (
                  <>
                    <div className="field-wrapper search-wrapper">
                      <label htmlFor="searchText" className="filter-label">
                        Search By Tender Id
                      </label>
                      <div className="input-with-icon">
                        <svg
                          className="icon search-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          aria-hidden
                        >
                          <path
                            fill="none"
                            stroke="#9fbfe8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                          />
                        </svg>
                        <input
                          id="searchText"
                          name="searchText"
                          placeholder="Search By Tender Id"
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          className="filter-input search-input"
                          style={{ width: "90%" }}
                        />
                      </div>
                    </div>
                    <div className="field-wrapper search-wrapper">
                      <label htmlFor="searchText" className="filter-label">
                        Search By Client Name
                      </label>
                      <div className="input-with-icon">
                        <svg
                          className="icon search-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          aria-hidden
                        >
                          <path
                            fill="none"
                            stroke="#9fbfe8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                          />
                        </svg>
                        <input
                          id="searchClient"
                          name="searchClient"
                          placeholder="Search By Client Name"
                          type="text"
                          value={clientname}
                          onChange={(e) => setClientname(e.target.value)}
                          className="filter-input search-input"
                          style={{ width: "90%" }}
                        />
                      </div>
                    </div>
                    <div className="field-wrapper search-wrapper">
                      <label htmlFor="searchText" className="filter-label">
                        Search By Tender Name
                      </label>
                      <div className="input-with-icon">
                        <svg
                          className="icon search-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          aria-hidden
                        >
                          <path
                            fill="none"
                            stroke="#9fbfe8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                          />
                        </svg>
                        <input
                          id="searchText"
                          name="searchText"
                          placeholder="Search By Tender Name"
                          type="text"
                          value={tendername}
                          onChange={(e) => setTendername(e.target.value)}
                          className="filter-input search-input"
                          style={{ width: "90%" }}
                        />
                      </div>
                    </div>

                    <div className="field-wrapper select-wrapper">
                      <label className="filter-label">Emd Type</label>
                      <select
                        name="emdType"
                        value={emdType}
                        onChange={(e) => setEmdType(e.target.value)}
                        className="filter-input select-input"
                      >
                        <option value="">Select Emd Type</option>
                        {EmdType.map((emd) => (
                          <option value={emd.key}>{emd.value}</option>
                        ))}
                      </select>
                    </div>
                  </>
                )}

                {toggleState === 5 && (
                  <>
                    <div className="field-wrapper search-wrapper">
                      <label htmlFor="searchText" className="filter-label">
                        Search By Project Name
                      </label>
                      <div className="input-with-icon">
                        <svg
                          className="icon search-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          aria-hidden
                        >
                          <path
                            fill="none"
                            stroke="#9fbfe8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                          />
                        </svg>
                        <input
                          id="searchText"
                          name="searchText"
                          placeholder="Search By Project Name"
                          type="text"
                          value={projectname}
                          onChange={(e) => setProjectname(e.target.value)}
                          className="filter-input search-input"
                          style={{ width: "90%" }}
                        />
                      </div>
                    </div>
                    <div className="field-wrapper search-wrapper">
                      <label htmlFor="searchText" className="filter-label">
                        Search By Emd Type
                      </label>
                      <div className="input-with-icon">
                        <svg
                          className="icon search-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          aria-hidden
                        >
                          <path
                            fill="none"
                            stroke="#9fbfe8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                          />
                        </svg>
                        <input
                          id="searchText"
                          name="searchText"
                          placeholder="Search By Emd Type"
                          type="text"
                          value={emdtypeold}
                          onChange={(e) => setEmdTypeold(e.target.value)}
                          className="filter-input search-input"
                          style={{ width: "90%" }}
                        />
                      </div>
                    </div>
                    <div className="field-wrapper select-wrapper">
                      <label className="filter-label">
                        Search By Expire Date Range
                      </label>
                      <div className="input-with-icon date-input-wrapper">
                        <DateRangePicker
                          startDate={selectedFromDate}
                          endDate={selectedToDate}
                          placeHolder1="DD/MM/YYYY"
                          placeHolder2="DD/MM/YYYY"
                          onChange={(start, end) => {
                            setFromDate(start);
                            setToDate(end);
                          }}
                          className="custom-range-picker"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>

        {/* {toggleState === 4 && (
                        <div className="sub-tab-container">
                            <button
                                className={bgSubTab === "new" ? "sub-tab active" : "sub-tab"}
                                onClick={() => setBgSubTab("new")}
                            >
                                Emd New
                            </button>

                            <button
                                className={bgSubTab === "old" ? "sub-tab active" : "sub-tab"}
                                onClick={() => setBgSubTab("old")}
                            >
                                Emd Old
                            </button>
                        </div>
                    )} */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "8px",
            paddingRight: "4px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              background: "#fff",
              border: "1px solid #d0e4f7",
              borderRadius: "8px",
              padding: "6px 12px",
              boxShadow: "0 1px 4px rgba(11,133,216,0.07)",
            }}
          >
            <span style={{ fontSize: "13px", color: "#555", fontWeight: 500 }}>
              Sort by Due Date:
            </span>
            <button
              onClick={() => setDueDateSort("asc")}
              style={{
                padding: "4px 12px",
                borderRadius: "6px",
                border: `1.5px solid ${dueDateSort === "asc" ? "#0b85d8" : "#ccc"}`,
                background: dueDateSort === "asc" ? "#e8f4fd" : "#f5f5f5",
                color: dueDateSort === "asc" ? "#0b85d8" : "#666",
                fontWeight: dueDateSort === "asc" ? 600 : 400,
                cursor: "pointer",
                fontSize: "12px",
                transition: "all 0.2s",
              }}
            >
              ↑ Oldest First
            </button>
            <button
              onClick={() => setDueDateSort("desc")}
              style={{
                padding: "4px 12px",
                borderRadius: "6px",
                border: `1.5px solid ${dueDateSort === "desc" ? "#0b85d8" : "#ccc"}`,
                background: dueDateSort === "desc" ? "#e8f4fd" : "#f5f5f5",
                color: dueDateSort === "desc" ? "#0b85d8" : "#666",
                fontWeight: dueDateSort === "desc" ? 600 : 400,
                cursor: "pointer",
                fontSize: "12px",
                transition: "all 0.2s",
              }}
            >
              ↓ Newest First
            </button>
          </div>
        </div>
        <div className="table-css-white-background">
          {console.log("condition ", toggleState !== 5 || bgSubTab === "old")}
          {/* ✅ BG NEW */}
          {(toggleState !== 5 ||
            (toggleState === 4 && bgSubTab === "new") ||
            toggleState === 1 ||
            toggleState === 2 ||
            toggleState === 3) && (
            <div className="table-containers">
              <div className="table-wrappers">
                <table className="tables">
                  <thead className="table-headers">
                    <tr className="header-rows">
                      <th className="table-cells header-cells">Sr.No.</th>
                      <th
                        className="table-cells header-cells"
                        style={{ textAlign: "center" }}
                      >
                        Tender
                      </th>
                      {/* <th className="table-cells header-cells">Tender Name</th> */}
                      <th className="table-cells header-cells">Sector</th>
                      <th className="table-cells header-cells">Client</th>
                      <th className="table-cells header-cells">PBG Required</th>
                      <th className="table-cells header-cells">EMD Required</th>
                      <th className="table-cells header-cells">Exempted EMD</th>
                      <th className="table-cells header-cells">EMD Type</th>
                      <th className="table-cells header-cells">EMD Amount</th>
                      <th className="table-cells header-cells">
                        EMD Submission Type
                      </th>
                      <th className="table-cells header-cells">
                        Submission Date
                      </th>
                      <th className="table-cells header-cells">Due Date</th>
                      <th className="table-cells header-cells">Lead Partner</th>
                      <th className="table-cells header-cells">JV Partner</th>
                      <th className="table-cells header-cells">
                        Associate Partner
                      </th>

                      {(toggleState === 2 ||
                        toggleState === 3 ||
                        toggleState === 4) && (
                        <>
                          <th className="table-cells header-cells">
                            EMD Created
                          </th>
                          <th className="table-cells header-cells">
                            EMD Created By
                          </th>
                          <th className="table-cells header-cells">
                            EMD Created On Behalf
                          </th>
                          <th className="table-cells header-cells">
                            Payer Bank
                          </th>
                          <th className="table-cells header-cells">
                            Account No
                          </th>
                          <th className="table-cells header-cells">
                            Account Holder
                          </th>
                          <th className="table-cells header-cells">
                            EMD Creation Date
                          </th>
                          <th className="table-cells header-cells">
                            EMD Expiry Date
                          </th>
                          <th className="table-cells header-cells">
                            EMD Transaction Date
                          </th>
                          <th className="table-cells header-cells">Ref No</th>
                          <th className="table-cells header-cells">NEFT ID</th>
                          <th className="table-cells header-cells">
                            Transaction ID
                          </th>
                          <th className="table-cells header-cells">
                            EMD Proof
                          </th>
                          <th className="table-cells header-cells">Status</th>
                        </>
                      )}

                      {(toggleState === 3 ||
                        toggleState === 4 ||
                        toggleState === 2) && (
                        <th className="table-cells header-cells">Due Days</th>
                      )}

                      <th className="table-cells header-cells">Action</th>
                    </tr>
                  </thead>

                  <tbody className="table-bodies">
                    {buffer ? (
                      <tr className="loading-rows">
                        <td colSpan="100" className="loading-cells">
                          <div className="spinner-bgdatail"></div>
                        </td>
                      </tr>
                    ) : filteredData.length > 0 ? (
                      filteredData
                        ?.filter((i) => {
                          switch (toggleState) {
                            case 1:
                              return (
                                i?.is_in_upcoming &&
                                !i?.is_in_created &&
                                !i?.is_submitted &&
                                !i?.is_matured
                              );
                            case 2:
                              return (
                                i?.is_in_upcoming &&
                                i?.is_in_created &&
                                !i?.is_submitted &&
                                !i?.is_matured
                              );
                            case 3:
                              return (
                                i?.is_in_upcoming &&
                                i?.is_in_created &&
                                i?.is_submitted &&
                                !i?.is_matured
                              );
                            case 4:
                              return (
                                i?.is_in_upcoming &&
                                i?.is_in_created &&
                                i?.is_submitted &&
                                i?.is_matured
                              );
                            default:
                              return true;
                          }
                        })
                        ?.sort((a, b) => {
                          const dateA = new Date(a?.submission_date || 0);
                          const dateB = new Date(b?.submission_date || 0);
                          return dueDateSort === "asc"
                            ? dateA - dateB
                            : dateB - dateA;
                        })
                        ?.map((item, index) => (
                          <tr key={item.id} className="data-rows">
                            <td className="table-cells">{index + 1}</td>
                            {/* <td className="table-cells">{item.tender_id || '-'}</td>
                                                        <td className="table-cells">{item.tender_name || '-'}</td> */}
                            <td className="align-center">
                              <div
                                style={{
                                  maxWidth: "220px",
                                  margin: "0 auto",
                                }}
                              >
                                <div style={{ fontWeight: "600" }}>
                                  {item.tender_id || "-"}
                                </div>

                                <div
                                  title={item.tender_name || ""}
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    fontSize: "12px",
                                    color: "#555",
                                  }}
                                >
                                  {item.tender_name || "-"}
                                </div>
                              </div>
                            </td>
                            <td className="table-cells">
                              {item.sector || "-"}
                            </td>
                            <td className="table-cells">
                              {item.client || "-"}
                            </td>
                            <td className="table-cells">
                              {formatBoolean(item.pbg_requried)}
                            </td>
                            <td className="table-cells">
                              {formatBoolean(item.is_emd_required)}
                            </td>
                            <td className="table-cells">
                              {formatBoolean(item.exmpted_emd)}
                            </td>
                            <td className="table-cells">
                              {(() => {
                                const multi = item.emd_type_multi?.length
                                  ? item.emd_type_multi.map((item) =>
                                      item
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (c) =>
                                          c.toUpperCase(),
                                        ),
                                    )
                                  : [];

                                const single = item.emd_type
                                  ? [
                                      item.emd_type
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (c) =>
                                          c.toUpperCase(),
                                        ),
                                    ]
                                  : [];

                                const result = [...multi, ...single];

                                return result.length ? result.join(", ") : "";
                              })()}
                            </td>
                            <td className="table-cells">
                              {item.emd_amount ? `${item.emd_amount}` : "-"}
                            </td>
                            <td className="table-cells">
                              {item.emd_submission_type || "-"}
                            </td>
                            <td className="table-cells">
                              {formatDate(item.submission_date)}
                            </td>
                            <td className="table-cells">
                              {formatDate(item.due_date)}
                            </td>
                            <td className="table-cells">
                              {item.lead_partner || "-"}
                            </td>
                            <td className="table-cells">
                              {item.jv_partner_name || "-"}
                            </td>
                            <td className="table-cells">
                              {item.assosiate_partner || "-"}
                            </td>

                            {(toggleState === 2 ||
                              toggleState === 3 ||
                              toggleState === 4) && (
                              <>
                                <td className="table-cells">
                                  {formatBoolean(item.bg_created)}
                                </td>
                                <td className="table-cells">
                                  {item.bg_created_by || "-"}
                                </td>
                                <td className="table-cells">
                                  {item.bg_created_on_behalf_of || "-"}
                                </td>
                                <td className="table-cells">
                                  {item?.payer_bank?.toUpperCase() || "-"}
                                </td>
                                <td className="table-cells">
                                  {item.account_number || "-"}
                                </td>
                                <td className="table-cells">
                                  {item.name_of_account_holder || "-"}
                                </td>
                                <td className="table-cells">
                                  {formatDate(item.bg_creation_date)}
                                </td>
                                <td className="table-cells">
                                  {formatDate(item.bg_expiry_date)}
                                </td>
                                <td className="table-cells">
                                  {formatDate(item.bg_transcation_date)}
                                </td>
                                <td className="table-cells">
                                  {item.ref_no || "-"}
                                </td>
                                <td className="table-cells">
                                  {item.neft_transaction_id || "-"}
                                </td>
                                <td className="table-cells">
                                  {item.transcation_id || "-"}
                                </td>
                                <td className="table-cells">
                                  {item.emd_created_proof ? (
                                    <a
                                      href={item.emd_created_proof}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="proof-links"
                                    >
                                      View
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td className="table-cells status-cells">
                                  <div className="status-badges">
                                    <span className="badge-blues">
                                      Tech Open: {item.tech_open ? "Yes" : "No"}
                                    </span>
                                    <span className="badge-greens">
                                      L1: {item.are_we_l1 ? "Yes" : "No"}
                                    </span>
                                  </div>
                                </td>
                              </>
                            )}

                            {(toggleState === 3 ||
                              toggleState === 4 ||
                              toggleState === 2) && (
                              <td className="table-cells due-days-cells">
                                {(() => {
                                  let days = "-";

                                  if (toggleState === 4) {
                                    // 👉 Calculate (today - result_open)
                                    if (item.result_open) {
                                      const today = new Date();
                                      const resultDate = new Date(
                                        item.result_open,
                                      );

                                      const diffTime = today - resultDate;
                                      days = Math.floor(
                                        diffTime / (1000 * 60 * 60 * 24),
                                      );
                                    }
                                  } else {
                                    // 👉 Existing logic
                                    days = getDueDays(
                                      item.bg_expiry_date,
                                      item.bg_transcation_date,
                                    );
                                  }

                                  return (
                                    <span
                                      className={
                                        (days !== "-" && days < 3) ||
                                        toggleState === 4
                                          ? "due-days-alert"
                                          : ""
                                      }
                                    >
                                      {days === "-" ? "-" : `${days} days`}
                                    </span>
                                  );
                                })()}
                              </td>
                            )}

                            <td className="table-cells action-cells">
                              <div className="action-buttons">
                                <UpdateBgDetails
                                  i={item}
                                  getBgDetails={getBgDetails}
                                  toggleState={toggleState}
                                />
                                {toggleState === 4 ||
                                toggleState === 1 ? null : (
                                  <Addtocart
                                    i={item}
                                    getBgDetails={getBgDetails}
                                    toggleState={toggleState}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr className="empty-rows">
                        <td colSpan="100" className="empty-cells">
                          No BG details found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ✅ BG OLD */}
          {(toggleState === 5 || (toggleState === 4 && bgSubTab === "old")) && (
            <>
              <div className="repo-heading flex-row justify-between">
                <span>BG Old Records</span>
                <UploadBgOld getBgOldData={getBgDetailsold} />
              </div>

              <div
                className="table-box height-73vh"
                style={{ overflowX: "auto" }}
              >
                <table className="table-css" style={{ minWidth: "2800px" }}>
                  <thead className="table-heading">
                    <tr className="custom-table-head-tr">
                      <th>Sr. No</th>
                      <th>Project Name</th>
                      <th>Project Detail</th>
                      <th>BG</th>
                      <th>Work Type</th>

                      <th>Lead Firm</th>
                      <th>JV</th>
                      <th>Association Firm</th>
                      <th>On Behalf Of</th>

                      <th>Type</th>
                      <th>Security Type</th>
                      <th>BG No</th>

                      <th>Issue Date</th>
                      <th>Expiry Date</th>
                      <th>Claim Period</th>

                      <th>Beneficiary</th>
                      <th>Amount</th>
                      <th>FD Number</th>

                      <th>Margin</th>
                      <th>Submitted To BD</th>
                      <th>Submitted Date</th>

                      <th>Person</th>
                      <th>Bank</th>
                      <th>Company</th>

                      <th>Limit</th>
                      <th>SFMS</th>
                      <th>Responsibility</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredData?.length > 0 ? (
                      filteredData.map((item, i) => (
                        <tr key={i} className="custom-table-head-td">
                          <td>{i + 1 || "-"}</td>
                          <td>{item.project_name || "-"}</td>
                          <td>{item.project_name_in_detail || "-"}</td>
                          <td>{item.bg || "-"}</td>
                          <td>{item.work_type || "-"}</td>

                          <td>{item.lead_firm || "-"}</td>
                          <td>{item.jv || "-"}</td>
                          <td>{item.association_firm || "-"}</td>
                          <td>{item.on_behalf_of || "-"}</td>

                          <td>{item.type || "-"}</td>
                          <td>{item.type_of_security || "-"}</td>
                          <td>{item.bank_gurentee_no || "-"}</td>

                          <td>{formatDate(item.bank_gurentee_issue_date)}</td>
                          <td>{formatDate(item.bg_expiry_date)}</td>
                          <td>{formatDate(item.claim_period)}</td>

                          <td>{item.benificiary_name || "-"}</td>
                          <td>{item.bg_amount || "-"}</td>
                          <td>{item.fd_number || "-"}</td>

                          <td>{item.margin || "-"}</td>
                          <td>{item.submitted_to_bd_dept || "-"}</td>
                          <td>{formatDate(item.submitted_date)}</td>

                          <td>{item.person_name || "-"}</td>
                          <td>{item.bank_name || "-"}</td>
                          <td>{item.company_name || "-"}</td>

                          <td>{item.limit || "-"}</td>
                          <td>{item.sfms || "-"}</td>
                          <td>{item.responsibility || "-"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="26" className="text-center">
                          No BG Old Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default SubmittedTender;
